import type { CommentsSubject } from '../../../comments/subject/comments-subject';

type TaskCommentsSubjectInput = {
    architectureId: string;
    canComment?: boolean;
    hasStagedChanges?: boolean;
    language: string;
    taskId: string;
    taskVersionId?: string;
};

export const createTaskCommentsSubject = ({
    architectureId,
    canComment = true,
    hasStagedChanges = false,
    language,
    taskId,
    taskVersionId,
}: TaskCommentsSubjectInput): CommentsSubject => {
    const isPersisted = taskVersionId !== undefined;

    return {
        architectureId,
        canCreateThreads: canComment && isPersisted && !hasStagedChanges,
        kind: 'profile-task',
        language,
        persistence: isPersisted ? 'persisted' : 'unsaved',
        subjectId: taskId,
        subjectVersion: taskVersionId ?? 'unsaved',
        // The backend addresses work-task comments by the integer task version.
        transportVersion: isPersisted ? Number(taskVersionId) : 'unsaved',
    };
};
